import {
  parsePasPracticeLibrary,
  type PasPracticeLibraryItem,
} from './pasPracticeLibrary';

const TTQ_LADDER_PRACTICE_KEY = 'ttqLadderPractice';

export function readTtqLadderPracticeItems(
  metadata: Record<string, unknown> | null | undefined,
): PasPracticeLibraryItem[] {
  const raw = metadata?.[TTQ_LADDER_PRACTICE_KEY];
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) {
    return [];
  }
  return parsePasPracticeLibrary((raw as Record<string, unknown>).anchorPracticeItems);
}

export function writeTtqLadderPracticeMetadata(
  metadata: Record<string, unknown> | null | undefined,
  items: PasPracticeLibraryItem[],
): Record<string, unknown> {
  const next = { ...(metadata || {}) };
  next[TTQ_LADDER_PRACTICE_KEY] = {
    anchorPracticeItems: items,
  };
  return next;
}

export function clearTtqLadderPracticeMetadata(
  metadata: Record<string, unknown> | null | undefined,
): Record<string, unknown> {
  const next = { ...(metadata || {}) };
  delete next[TTQ_LADDER_PRACTICE_KEY];
  return next;
}
